import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isNull from "lodash/isNull";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.is-array.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'components/UI';
import { showApiError } from 'utils';
import { getAllMunicipality, getAllCities } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";

var AddressInput = function AddressInput(_ref) {
  var formProps = _ref.formProps,
      areaKey = _ref.areaKey,
      municipalityKey = _ref.municipalityKey,
      cityKey = _ref.cityKey,
      countryId = _ref.countryId,
      areas = _ref.areas,
      isNew = _ref.isNew,
      _ref$initialMunicipal = _ref.initialMunicipalities,
      initialMunicipalities = _ref$initialMunicipal === void 0 ? [] : _ref$initialMunicipal,
      _ref$initialCities = _ref.initialCities,
      initialCities = _ref$initialCities === void 0 ? [] : _ref$initialCities;

  var _useState = useState(initialMunicipalities),
      _useState2 = _slicedToArray(_useState, 2),
      municipalities = _useState2[0],
      setMunicipalities = _useState2[1];

  var _useState3 = useState(initialCities),
      _useState4 = _slicedToArray(_useState3, 2),
      cities = _useState4[0],
      setCities = _useState4[1];

  var areaInputRef = useRef();
  var municipalityInputRef = useRef();
  var cityInputRef = useRef();
  var values = formProps.mergedValues,
      setValues = formProps.setValues,
      isTouched = formProps.isTouched;
  useEffect(function () {
    if (isTouched) {
      var _areaInputRef$current, _municipalityInputRef, _cityInputRef$current;

      (_areaInputRef$current = areaInputRef.current) === null || _areaInputRef$current === void 0 ? void 0 : _areaInputRef$current.changeIsTouched(true);
      (_municipalityInputRef = municipalityInputRef.current) === null || _municipalityInputRef === void 0 ? void 0 : _municipalityInputRef.changeIsTouched(true);
      (_cityInputRef$current = cityInputRef.current) === null || _cityInputRef$current === void 0 ? void 0 : _cityInputRef$current.changeIsTouched(true);
    }
  }, [isTouched]);
  useEffect(function () {
    if (values !== null && values !== void 0 && values[areaKey] && initialMunicipalities.length === 0) fetchMunicipalities(values === null || values === void 0 ? void 0 : values[areaKey]);
    if (values !== null && values !== void 0 && values[areaKey] && values !== null && values !== void 0 && values[municipalityKey] && initialCities.length === 0) fetchCities(values === null || values === void 0 ? void 0 : values[areaKey], values === null || values === void 0 ? void 0 : values[municipalityKey]);
  }, []);

  var fetchMunicipalities = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(areaId) {
      var _yield$getAllMunicipa, _yield$getAllMunicipa2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllMunicipality({
                country_id: countryId,
                area_id: areaId
              });

            case 2:
              _yield$getAllMunicipa = _context.sent;
              _yield$getAllMunicipa2 = _slicedToArray(_yield$getAllMunicipa, 2);
              res = _yield$getAllMunicipa2[0];
              err = _yield$getAllMunicipa2[1];
              err ? showApiError(err) : setMunicipalities(res);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchMunicipalities(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var fetchCities = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(areaId, municipalityId) {
      var _yield$getAllCities, _yield$getAllCities2, res, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getAllCities({
                country_id: countryId,
                area_id: areaId,
                municipality_id: municipalityId
              });

            case 2:
              _yield$getAllCities = _context2.sent;
              _yield$getAllCities2 = _slicedToArray(_yield$getAllCities, 2);
              res = _yield$getAllCities2[0];
              err = _yield$getAllCities2[1];
              err ? showApiError(err) : setCities(res);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchCities(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Dropdown, {
    ref: areaInputRef,
    noClear: true,
    required: true,
    withSearch: true,
    displayKey: "name",
    uniqueKey: "id",
    label: "\u041E\u0431\u043B\u0430\u0441\u0442",
    options: areas,
    value: values[areaKey],
    onChange: function onChange(val) {
      fetchMunicipalities(val === null || val === void 0 ? void 0 : val.id);
      setCities([]);
      _isFunction(setValues) && setValues(function (prev) {
        var _objectSpread2;

        return _objectSpread(_objectSpread({}, prev), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, areaKey, val === null || val === void 0 ? void 0 : val.id), _defineProperty(_objectSpread2, municipalityKey, null), _defineProperty(_objectSpread2, cityKey, null), _objectSpread2));
      });
    }
  }), ___EmotionJSX(Dropdown, {
    ref: municipalityInputRef,
    withSearch: true,
    required: true,
    displayKey: "name",
    uniqueKey: "id",
    label: "\u041E\u0431\u0449\u0438\u043D\u0430",
    options: municipalities,
    value: values[municipalityKey],
    onChange: function onChange(val) {
      if (_isNull(val)) setCities([]);else fetchCities(values === null || values === void 0 ? void 0 : values[areaKey], val === null || val === void 0 ? void 0 : val.id);
      _isFunction(setValues) && setValues(function (prev) {
        var _val$id, _objectSpread3;

        return _objectSpread(_objectSpread({}, prev), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, municipalityKey, (_val$id = val === null || val === void 0 ? void 0 : val.id) !== null && _val$id !== void 0 ? _val$id : null), _defineProperty(_objectSpread3, cityKey, null), _objectSpread3));
      });
    }
  }), ___EmotionJSX(Dropdown, {
    ref: cityInputRef,
    withSearch: true,
    required: true,
    displayKey: "name",
    uniqueKey: "id",
    label: "\u0413\u0440\u0430\u0434/\u0441\u0435\u043B\u043E",
    options: cities,
    value: values[cityKey],
    onChange: function onChange(val) {
      _isFunction(setValues) && setValues(function (prev) {
        var _val$id2;

        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, cityKey, (_val$id2 = val === null || val === void 0 ? void 0 : val.id) !== null && _val$id2 !== void 0 ? _val$id2 : null));
      });
    }
  }));
};

AddressInput.propTypes = {
  areaKey: PropTypes.string,
  municipalityKey: PropTypes.string,
  cityKey: PropTypes.string,
  countryId: PropTypes.number,
  areas: PropTypes.array,
  isNew: PropTypes.bool,
  formProps: PropTypes.object,
  initialMunicipalities: PropTypes.array,
  initialCities: PropTypes.array
};
export default AddressInput;